import { Button, ButtonProps } from '@mui/material'
import React from 'react'

export type AlertButtonVariant = 'contained' | 'outlined'

type Props = Omit<ButtonProps, 'variant' | 'color'> & {
  variant: AlertButtonVariant
}

export const AlertButton = ({ variant, sx, ...props }: Props) => (
  <Button
    variant={variant}
    color="info"
    sx={{
      minWidth: '6.25rem',
      ...(variant === 'outlined' && { bgcolor: 'common.white' }),
      ...sx,
    }}
    {...props}
  />
)
